/* eslint import/prefer-default-export:off */
export const wpFootnoteClass  = 'cdm-footnote-container';
export const wpChapterClass   = 'cdm-guide-chapter-title';
export const wpSectionClass   = 'cdm-guide-section-title';
export const dataGuideIdProp = 'data-guideid';

export const latestMediaBlockClassName = 'wp-block-cdm-latestmediatool-latestmediatool';
export const latestMediaContainerClassName = 'cdm-latestmedia-container';
export const storyCardClassName = 'wp-block-cdm-latestmediatool-latestmediastoryheader';
export const videoCardClassName = 'wp-block-cdm-latestmediatool-latestmediavideoheader';